import { useEffect, useState } from 'react';

export interface TopWinsLayout {
  cols: number;
  rows: number;
}

const DESKTOP_LAYOUT: TopWinsLayout = { cols: 4, rows: 3 };
const NARROW_LANDSCAPE_LAYOUT: TopWinsLayout = { cols: 3, rows: 3 };
const SMALL_LANDSCAPE_LAYOUT: TopWinsLayout = { cols: 2, rows: 3 };
const PORTRAIT_LAYOUT: TopWinsLayout = { cols: 1, rows: 3 };

// Must stay in sync with the column-count media queries in
// TopWinsSection.module.css. Width-driven, orientation-agnostic — col count
// adapts to viewport width regardless of orientation. 218px min everywhere;
// cards stretch beyond that to fill the available width.
const detectLayout = (): TopWinsLayout => {
  if (typeof window === 'undefined') return DESKTOP_LAYOUT;

  if (window.matchMedia('(max-width: 659px)').matches) return PORTRAIT_LAYOUT;
  if (window.matchMedia('(max-width: 858px)').matches) return SMALL_LANDSCAPE_LAYOUT;
  if (window.matchMedia('(max-width: 1439px)').matches) return NARROW_LANDSCAPE_LAYOUT;
  return DESKTOP_LAYOUT;
};

export const useVisibleLayout = (): TopWinsLayout => {
  const [layout, setLayout] = useState<TopWinsLayout>(detectLayout);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const update = () => {
      setLayout((prev) => {
        const next = detectLayout();
        return prev.cols === next.cols && prev.rows === next.rows ? prev : next;
      });
    };

    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);
    return () => {
      window.removeEventListener('resize', update);
      window.removeEventListener('orientationchange', update);
    };
  }, []);

  return layout;
};
